<template>
	<section role="main" class="content-body">
		<header class="page-header">
			<h2>首頁</h2>
			<div class="right-wrapper">
				<ol class="breadcrumbs">
					<li>
						<router-link to="/index">
							<i class="fa fa-home"></i>
						</router-link>
					</li>
				</ol>
			</div>
		</header>
		<div class="row">
			<div class="col-md-12">
				<section ></section>
			</div>
		</div>
	</section>
</template>
<script>
export default {
	name: "index",
	mounted: function(){
		
	}
}
</script>
<style>

</style>